import { Injectable } from '@angular/core';
import { Game, GenericMedia } from './game.model';

@Injectable({ providedIn: 'root' })
export class GamesService
{
    private games: Game[] = [
        // {
        //     transKey: 'coinsCollector',
        //     id: 'coins-collector',
        //     name: 'Coins Collector',
        //     description: 'Pick up spawned coins while staying in safe areas during start/end; avoid moving obstacles. Lose on hit/timeout; win by clearing waves/score.',
        // TODO: REVIEW THIS! (iahsjkdh)
        //     layers: 'Layers: safe area, coins, obstacles, collision feedback, win/lose covers, player steps.',
        //     balancing: [
        //         { key: 'roundDuration', param: 'Round Duration', values: { Kids: '~20s', Beginner: '~20s', Intermediate: '~20s', Hard: '~20s', VeryHard: '~20s' } },
        //         { key: 'coinsPerWave', param: 'Coins per wave', values: { Kids: '16->24', Beginner: '20->36', Intermediate: '24->? (+3)', Hard: '28->? (+4)', VeryHard: '32->? (+5)' } },
        //         { key: 'obstaclesDensity', param: 'Obstacles density', values: { Kids: '10->18 pixels', Beginner: '14->30 pixels', Intermediate: '18->? (+3)', Hard: '22->? (+4)', VeryHard: '26->? (+5)' } },
        //     ],
        //     images: [],
        //     video: '',
        // },
        // {
        //     transKey: 'geomemory',
        //     id: 'geomemory',
        //     name: 'Geomemory',
        //     description: 'Show a geometric pattern, hide it, players must reproduce by stepping on correct tiles; loops with increasing pattern size.',
        // TODO: REVIEW THIS! (iahsjkdh)
        //     layers: 'Layers: geometry draw, collision feedback, success/warning/fail covers.',
        //     balancing: [],
        //     levels: [
        //         { level: '0-1', pixels: '2x2', draw: '2x2' },
        //         { level: '2-3', pixels: '3x3', draw: '2x2' },
        //         { level: '4-5', pixels: '3x4', draw: '2x3' },
        //         { level: '6-7', pixels: '3x4', draw: '2x4' },
        //         { level: '8-9', pixels: '4x5', draw: '2x4' },
        //     ],
        //     images: [],
        //     video: '',
        // },
        {
            transKey: 'extremeCrossing',
            id: 'extreme-crossing',
            name: 'Extreme Crossing',

            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-extreme-crossing-02.jpg',
            // summary: "The players have to dodge obstacles to get to the other side of the room. When all the players reach the other side, the end becomes the beginning and vice versa.",

            description: 'Cross from bottom to top dodging moving lines/obstacles; mid safe area optional; finish triggers win, hit/timeout triggers fail.',
            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: obstacles group, goals safe areas, middle safe area, countdown, covers, collision flashes, success/fail covers.',
            balancing: [
                { key: 'roundDuration', param: 'Round Duration', values: { Kids: '~40s', Beginner: '~38s', Intermediate: '~34s', Hard: '~30s', VeryHard: '~25-30s' } },
                { key: 'obstacleStep', param: 'Obstacle step', values: { Kids: '~0.55s', Beginner: '~0.50s', Intermediate: '~0.45s', Hard: '~0.38s', VeryHard: '~0.35s' } },
                { key: 'goalSize', param: 'Goal size', values: { Kids: 'Goal up to 2x2', Beginner: 'Small', Intermediate: 'Smaller', Hard: 'Smaller + tighter mid safe', VeryHard: 'Smallest' } },
            ],
            images: [
                'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-extreme-crossing-02.jpg',
                'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/extreme-crossing-01-thumbnail-01.jpg',
            ],
            video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/extreme-crossing-01-trailer-01.mp4',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/extreme-crossing-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                {
                    Id: 'video-02',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/extreme-crossing-trailer-lite-room-v1-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-extreme-crossing-02.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/extreme-crossing-01-thumbnail-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/photos/extreme-crossing-game-mode-thumbnail-01-lite-room-sprite.jpg',
                },
            ],
            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Dash upward across moving hazard lines and test your timing and teamwork. Some levels feature an optional mid-level safety zone, allowing players to pause, regroup, and plan their next move before pushing forward.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'To win the round, reach the green goal zones on the opposite side before time runs out or before all lives are lost.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'Stepping on red zones costs one life.',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'Lives are represented by hearts displayed on the TV screen.',
                        },
                        {
                            Id: 'list-01-03',
                            TextContent: 'Hearts are shared across all players - this is a collective survival challenge, not individual lives.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'If the wall option is enabled, a countdown timer is displayed on the wall, adding extra pressure as time ticks down.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Move fast, choose your moments wisely, and work together to make it across.',
                },
            ],
        },
        {
            transKey: 'colorPicker',
            id: 'color-picker',
            name: 'Color Picker',
            description: 'Memorize shown colored pixels, then step only on the target color when the grid hides/changes. Rounds loop with feedback and scoring multipliers.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/color-pecker-game-mode-thumbnail-01-max-room-sprite.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/color-picker-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/color-pecker-game-mode-thumbnail-01-max-room-sprite.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/color-picker-01-thumbnail-01.jpg',
                },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/color-pecker-game-mode-thumbnail-01-max-room-sprite.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/color-picker-01-thumbnail-01.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/color-picker-01-trailer-01.mp4',
            // GenericMediasList: [],
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: colors grid, dynamic collision paint, background/covers, countdown, flash feedback.',
            balancing: [
                { key: 'roundDuration', param: 'Round Duration', values: { Kids: '8s', Beginner: '6-7s', Intermediate: '5-6s', Hard: '4s', VeryHard: '3s' } },
                { key: 'pixelsToFind', param: 'Pixels to find', values: { Kids: '7-14', Beginner: '6-10', Intermediate: '5-8', Hard: '5-6', VeryHard: '4' } },
                { key: 'pieceSize', param: 'Piece size', values: { Kids: 'up to 3x3', Beginner: '2-3', Intermediate: '2-3', Hard: '2x2', VeryHard: '2x2' } },
                { key: 'scoreMult', param: 'Score mult', values: { Kids: '1x', Beginner: '2x', Intermediate: '3x', Hard: '4x', VeryHard: '5x' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Test your memory, speed, and teamwork in this fast-paced color recognition challenge.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'At the start of each round, the sound announces a color. If the wall option is enabled, the wall will also light up in the selected color, reinforcing the visual cue.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'Players then have a limited amount of time, based on the current level and difficulty, to locate and stand on the floor tiles matching the announced color.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'The game begins with larger color groupings scattered across the floor (such as 2×2, 3×3, or 4×4 clusters). As levels increase, the challenge intensifies:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'The color zones shrink in size, eventually down to 2x2 tiles.',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'The number and placement of correct tiles varies and becomes less predictable, ending after 12 phases.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'Each level defines how many target color zones players need to find in each round.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-02-01',
                            TextContent: 'The game is balanced for 4 players by default.',
                        },
                        {
                            Id: 'list-02-02',
                            TextContent: 'If the number of players is different, the target number of color zones is scaled proportionally to match the actual player count.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'Each level also defines a maximum size for color zones per round.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-03-01',
                            TextContent: 'At the start of a round, the game calculates the maximum number of zones that could exist.',
                        },
                        {
                            Id: 'list-03-02',
                            TextContent: 'The target number of zones is always kept below half of that maximum to ensure balanced gameplay.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'The game uses 8 possible colors.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-04-01',
                            TextContent: 'At the start of each round, one color is randomly selected as the current color.',
                        },
                        {
                            Id: 'list-04-02',
                            TextContent: 'This color is always different from the previous round’s color to avoid repetition.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-08',
                    Type: 'paragraph',
                    TextContent: 'Once the target number of zones is set:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-05-01',
                            TextContent: 'The game places that number of zones of the current color in random valid grid positions.',
                        },
                        {
                            Id: 'list-05-02',
                            TextContent: 'All remaining grid positions are filled randomly with the other available colors.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-09',
                    Type: 'paragraph',
                    TextContent: 'As players progress through levels:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-06-01',
                            TextContent: 'The number of target color zones decreases, and',
                        },
                        {
                            Id: 'list-06-02',
                            TextContent: 'The maximum size of each color zone also decreases, making the game more challenging.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-10',
                    Type: 'paragraph',
                    TextContent: 'This is a score-based, collaborative game. Players earn points after each round, and each difficulty level applies a score multiplier.',
                },
                {
                    Id: 'paragraph-11',
                    Type: 'paragraph',
                    TextContent: 'Each difficulty level defines a score value for correct and incorrect guesses.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-07-01',
                            TextContent: 'When the team wins a round, the score adds the difficulty’s right-guess value.',
                        },
                        {
                            Id: 'list-07-02',
                            TextContent: 'When the team loses a round, the score subtracts the difficulty’s wrong-guess value.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-12',
                    Type: 'paragraph',
                    TextContent: 'The values per difficulty are:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-08-01',
                            TextContent: 'Kids: 3',
                        },
                        {
                            Id: 'list-08-02',
                            TextContent: 'Beginner: 6',
                        },
                        {
                            Id: 'list-08-03',
                            TextContent: 'Intermediate: 9',
                        },
                        {
                            Id: 'list-08-04',
                            TextContent: 'Hard: 12',
                        },
                        {
                            Id: 'list-08-05',
                            TextContent: 'Very Hard: 15',
                        },
                    ],
                },
                {
                    Id: 'paragraph-13',
                    Type: 'paragraph',
                    TextContent: 'The score is shared by all players, counting as a single team score.',
                },
                {
                    Id: 'paragraph-14',
                    Type: 'paragraph',
                    TextContent: 'Players lose lives if they are standing on the wrong color when time expires. Lives are represented by hearts and are shared across all players on the floor. Success depends on collective decision-making.',
                },
                {
                    Id: 'paragraph-15',
                    Type: 'paragraph',
                    TextContent: 'After each round, the sound provides immediate feedback, signaling success or failure. As players advance, levels become progressively harder due to fewer correct tiles and tighter time windows.',
                },
                {
                    Id: 'paragraph-16',
                    Type: 'paragraph',
                    TextContent: 'Work together, move fast, and trust your instincts - every color choice matters.',
                },
            ],

        },
        {
            transKey: 'redLightGreenLight',
            id: 'red-light-green-light',
            name: 'Red Light Green Light',
            description: 'Advance during green, freeze during red; motion during red triggers fail; race to the goal before time ends.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-rlgl-01.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/rlgl-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-rlgl-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/rlgl-01-thumbnail-01.jpg',
                },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-rlgl-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/rlgl-01-thumbnail-01.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/rlgl-01-trailer-01.mp4',
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: safe areas, countdown, dynamic borders, feedback.',
            balancing: [
                { key: 'roundDuration', param: 'Round Duration', values: { Kids: '300s', Beginner: '240s', Intermediate: '195s', Hard: '165s', VeryHard: '120s' } },
                { key: 'maxBordersWidth', param: 'Max Borders Width', values: { Kids: '3', Beginner: '2', Intermediate: '1', Hard: '0', VeryHard: '0' } },
                { key: 'redLightAnticipation', param: 'Red Light Anticipation', values: { Kids: '0.30s', Beginner: '0.25s', Intermediate: '0.20s', Hard: '0.15s', VeryHard: '0.10s' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Work together to clear the floor before time runs out.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'This is a collaborative game where the objective is to collect and clear all red tiles on the floor. As players step on red tiles, they are deactivated and turned off, reducing the remaining tiles that need to be cleared.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'With the wall option enabled, the game is inspired by Red Light, Green Light:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'When the character is facing away (displayed on the wall), players may move freely.',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'When the character suddenly turns around, signaled by the song stopping, players must freeze immediately.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Any tiles players are standing on while frozen will turn green, marking them as safely cleared. Once the character turns back around, players can resume moving and continue clearing red tiles.',
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'If a player is caught moving when the character turns around, the team loses one shared life. If you step outside of the safety zone, it blinks continuously like in this video (https://www.instagram.com/reel/DRXBDhTke2d/?igsh=MW05a3VvN2RlcXdrcg%3D%3D).',
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'When the character is facing the players, the entire floor turns red. During this time, the safe area remains visible and stays green, and the tiles where players were standing last are converted into safe area tiles and also turn green.',
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'The team also has a limited amount of time, determined by the selected difficulty, to clear all red tiles on the floor. Lives are shared among all players, making coordination and timing essential.',
                },
                {
                    Id: 'paragraph-08',
                    Type: 'paragraph',
                    TextContent: 'Move together, freeze fast, and clear the floor before time and lives run out.',
                },
            ],

        },
        {
            transKey: 'secretPath',
            id: 'secret-path',
            name: 'Secret Path',
            description: 'Briefly reveal a hidden path, then players must follow it; wrong steps penalize; finish the route before time runs out.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/secret-path-01-thumbnail-01.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/secret-path-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/secret-path-01-thumbnail-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-secret-path-01.jpg',
                },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/secret-path-01-thumbnail-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-secret-path-01.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/secret-path-01-trailer-01.mp4',
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: path renderer/cover, countdown, feedback covers.',
            balancing: [
                { key: 'roundDuration', param: 'Round', values: { Kids: '60s', Beginner: '60s', Intermediate: '60s', Hard: '60s', VeryHard: '60s' } },
                { key: 'inspection', param: 'Inspection', values: { Kids: '15s', Beginner: '15s', Intermediate: '12s', Hard: '12s', VeryHard: '10s' } },
                { key: 'pathWidth', param: 'Path width', values: { Kids: '3', Beginner: '2', Intermediate: '2', Hard: '1', VeryHard: '1' } },
                { key: 'nodeDelta', param: 'Node delta', values: { Kids: '1', Beginner: '1', Intermediate: '2', Hard: '2', VeryHard: '4' } },
                { key: 'visualDuration', param: 'Visual duration', values: { Kids: '20s', Beginner: '15s', Intermediate: '12s', Hard: '7s', VeryHard: '2s' } },
                { key: 'scoreMult', param: 'Score mult', values: { Kids: '1x', Beginner: '2x', Intermediate: '3x', Hard: '4x', VeryHard: '5x' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Test your memory, coordination, and precision in this collaborative memorization challenge.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'At the start of each round, a hidden path briefly lights up in green on the floor, revealing the only safe route across the play area. Once the path disappears, players must remember and follow the correct tiles to make it to the opposite side.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'Based on the selected difficulty, players must successfully cross the secret path using only the allowed tiles before time runs out.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Stepping on an incorrect tile results in a life penalty, shared across all players.',
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'This is a score-based game. As players progress through higher levels, points earned increase based on a difficulty multiplier.',
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'As levels advance, the game becomes more challenging through longer paths, shorter reveal times, and tighter time limits.',
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'Remember the path, trust your team, and step carefully. One wrong move can cost everyone.',
                },
            ],

        },
        {
            transKey: 'goldRush',
            id: 'gold-rush',
            name: 'Gold Rush',
            description: 'Collect coins in a mine field while avoiding hazards; multiple rounds per difficulty, escalating counts; score for coins, penalties on hit.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-gold-rush-01.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/gold-rush-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-gold-rush-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/gold-rush-01-thumbnail-01.jpg',
                },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-gold-rush-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/gold-rush-01-thumbnail-01.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/gold-rush-01-trailer-01.mp4',
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: coins, obstacle layers per level, feedback covers.',
            balancing: [
                { key: 'roundDuration', param: 'Round Duration', values: { Kids: '20s', Beginner: '20s', Intermediate: '20s', Hard: '20s', VeryHard: '20s' } },
                { key: 'coinsPerWave', param: 'Coins per round', values: { Kids: '16->24 (+1)', Beginner: '20->36 (+2)', Intermediate: '24->? (+3)', Hard: '28->? (+4)', VeryHard: '32->? (+5)' } },
                { key: 'obstaclePixels', param: 'Obstacle pixels', values: { Kids: '10->18 (+1)', Beginner: '14->30 (+2)', Intermediate: '18->? (+3)', Hard: '22->? (+4)', VeryHard: '26->? (+5)' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Race against the clock and work together to collect every coin on the floor.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'Gold Rush is a collaborative game where the team must collect all yellow tiles (coins) before time runs out. Players score by stepping on yellow tiles, which are cleared as they are collected.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'Each round is time-based, and as the difficulty increases, the number of coins on the floor increases while the time limit remains the same, demanding faster movement and tighter coordination.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Beware of hazard coins, shown in red. If any player steps on a red tile, the team loses one shared life.',
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'If the team fails to collect all coins before the round timer ends, a penalty is applied.',
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'With the wall option enabled, the wall provides real-time visual feedback and game context.',
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'Lives are shared across all players, reinforcing teamwork and awareness. As rounds progress, increased coin density and hazards turn the floor into a fast-paced minefield where every step matters.',
                },
                {
                    Id: 'paragraph-08',
                    Type: 'paragraph',
                    TextContent: 'Move fast, communicate clearly, and collect wisely. Greed can cost the whole team.',
                },
            ],

        },
        {
            transKey: 'sprint',
            id: 'sprint',
            name: 'Sprint',
            description: 'Repeatedly spawns objectives; first to step on them scores; race to target score; tie-break by time/score.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-sprint-01.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/sprint-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-sprint-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/sprint-01-thumbnail-02.jpg',
                },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-sprint-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/sprint-01-thumbnail-02.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/sprint-01-trailer-01.mp4',
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: objectives, winner border, score wall, countdown, fireworks, feedback covers.',
            balancing: [
                { key: 'roundDuration', param: 'Round Duration', values: { Kids: '120s', Beginner: '100s', Intermediate: '85s', Hard: '70s', VeryHard: '55s' } },
                { key: 'targetScore', param: 'Target Score', values: { Kids: '14', Beginner: '14', Intermediate: '14', Hard: '14', VeryHard: '14' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Fast reactions win the race.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'Sprint is a competitive game where players face off against each other. Objectives spawn repeatedly on the floor, and the first player to step on a target scores points. As soon as one objective is claimed, another appears - keeping the pace nonstop and intense.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'The goal is to be the first player to reach the target score. If multiple players reach the target score at the same time, the winner is decided by:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'Fastest completion time, or',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'Highest total points, depending on game settings',
                        },
                    ],
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Quick movement, smart positioning, and split-second decisions are key. Hesitate, and someone else will take the point.',
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'Run fast. React faster. Win the Sprint.',
                },
            ],

        },
        {
            transKey: 'pacRush',
            id: 'pac-rush',
            name: 'Pac-Rush',
            description: 'Floor-scale Pac-Man: collect pellets, avoid enemies, occasional power-ups.',

            // media
            BannerImgUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/photos/pac-rush-01-photo-01.jpg',
            GenericMediasList: [
                {
                    Id: 'video-01',
                    Type: 'video',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/pac-rush-01-trailer-01.mp4',
                    Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/photos/pac-rush-01-photo-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-pac-rush-01.jpg',
                },
                {
                    Type: 'image',
                    SourceUrl: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/pac-rush-01-thumbnail-01.jpg',
                },
            ],
            // images: [
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/photos/pac-rush-01-photo-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/banners/game-modes-random-banners-v1-pac-rush-01.jpg',
            //     'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/thumbnails/pac-rush-01-thumbnail-01.jpg',
            // ],
            // video: 'https://ahap-gc-01-development-01.s3.sa-east-1.amazonaws.com/public/_app/features/games/trailers/pac-rush-01-trailer-01.mp4',
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: '',
            balancing: [],
            // note: 'Uses shared defaults; ghost speed/aggression not differentiated yet.',

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'A classic arcade game reimagined at full scale.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'Pac-Man is a dual-role game where players take on different responsibilities:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'One player controls Pac Rush from outside the floor, using a controller or interface.',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'The remaining players are the Ghosts, moving inside the interactive floor.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'The objective for Pac Rush is to collect all coins on the floor while avoiding the Ghosts. Coins disappear as Pac Rush collects them, increasing the score. The color of the coins is a white/grey color.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'Ghost players work together to block, corner, and catch Pac-Man by positioning themselves strategically on the floor.',
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'In Pac-Rush, in addition to the regular coins (equivalent to the small coins in the original Pac-Man), there are also large coins, which correspond to the power coins from the original game.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-02-01',
                            TextContent: 'Large coins temporarily put the ghosts into a frightened mode.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'The game also includes fruits, which appear temporarily at semi-random intervals.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-03-01',
                            TextContent: 'Fruits are not true power-ups.',
                        },
                        {
                            Id: 'list-03-02',
                            TextContent: 'They only grant bonus points internally.',
                        },
                        {
                            Id: 'list-03-03',
                            TextContent: 'This bonus score is not currently shown on the HUD.',
                        },
                        {
                            Id: 'list-03-04',
                            TextContent: 'Fruits appear on the right side of the wall.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'Visual behavior:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-04-01',
                            TextContent: 'Large coins are white, shown at full brightness, and blink by dimming and brightening.',
                        },
                        {
                            Id: 'list-04-02',
                            TextContent: 'Fruits are purple and blink by dimming.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-08',
                    Type: 'paragraph',
                    TextContent: 'The round ends when:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-05-01',
                            TextContent: 'Pac-Man clears all coins, or',
                        },
                        {
                            Id: 'list-05-02',
                            TextContent: 'Pac-Man is caught by the Ghosts (players on the tile) - you have 3 lives',
                        },
                    ],
                },
                {
                    Id: 'paragraph-09',
                    Type: 'paragraph',
                    TextContent: 'This asymmetric setup blends strategy, communication, and movement, making every round dynamic and unpredictable.',
                },
            ],
        },
        {
            transKey: 'roadSurfers',
            id: 'road-surfers',
            name: 'Road Surfers',
            description: 'Lane runner with per-player tracks; avoid obstacles, grab coins; requires all players in safe area before start; fastest or last survivor wins.',

            // media
            // BannerImgUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
            GenericMediasList: [
                // {
                //     Id: 'video-01',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                // },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: background, winner feedback, tracks list, countdown, player steps.',
            balancing: [
                { key: 'startFinalSpeed', param: 'Start->Final Speed', values: { Kids: '1.1->2.8', Beginner: '1.5->4.0', Intermediate: '2.0->5.0', Hard: '3.0->6.0', VeryHard: '4.0->7.0' } },
                { key: 'contentGap', param: 'Content Gap', values: { Kids: '3->1', Beginner: '3->1', Intermediate: '3->1', Hard: '3->1', VeryHard: '3->1' } },
                { key: 'coinsRate', param: 'Coins rate', values: { Kids: '0.75->0.55', Beginner: '0.65->0.45', Intermediate: '0.57->0.30', Hard: '0.50->0.25', VeryHard: '0.40->0.20' } },
                { key: 'maxRound', param: 'Max Round', values: { Kids: '~40s', Beginner: '~40s', Intermediate: '~40s', Hard: '~40s', VeryHard: '~40s' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Run fast, dodge smart, and stay in your lane.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'Road Surfers is a lane-based competitive game where each player has their own lane. All players must start in the designated safe area before the round begins.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'Once the game starts, players run forward in their lanes, dodging incoming obstacles and collecting coins along the way. Obstacles must be avoided, colliding with them can slow you down, cost points, or eliminate you, depending on game settings.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'In Road-Surfers, the wall displays a numeric timer.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'During the game’s main loop, the timer shows the remaining time until the round ends.',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'Before the main loop starts, the game has a start condition: each player must stay in a safe area for 3 seconds.',
                        },
                        {
                            Id: 'list-01-03',
                            TextContent: 'During this start condition, the same timer is used to count down those 3 seconds.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'In Road-Surfers, the concept of lives does not exist.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-02-01',
                            TextContent: 'Players do not have, gain, or lose lives.',
                        },
                        {
                            Id: 'list-02-02',
                            TextContent: 'No life-related mechanics are handled or displayed in the game',
                        },
                    ],
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'In Road-Surfers, each player’s score is tracked internally only and is used solely to determine the winner at the end of the round.',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-03-01',
                            TextContent: 'No scores are displayed to the players during gameplay.',
                        },
                        {
                            Id: 'list-03-02',
                            TextContent: 'Players gain points when they collect coins.',
                        },
                        {
                            Id: 'list-03-03',
                            TextContent: 'Players lose points when they step on obstacles.',
                        },
                    ],
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'Coins add an extra layer of strategy, rewarding risk-taking and quick reactions.',
                },
                {
                    Id: 'paragraph-08',
                    Type: 'paragraph',
                    TextContent: 'React quickly, stay in your lane, and surf the road to victory.',
                },
            ],

        },
        {
            transKey: 'plotInvaders',
            id: 'plot-invaders',
            name: 'Plot Invaders',
            description: 'Players on borders shoot toward the center while painting; defend center pixels and avoid incoming shots; rounds rotate player sides.',

            // media
            // BannerImgUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
            GenericMediasList: [
                // {
                //     Id: 'video-01',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 26 floor (with a 7 pixels wall)',
                // },
                // {
                //     Id: 'video-02',
                //     Type: 'video',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.mp4',
                //     Sumarry: 'Gameplay on a 14 x 14 floor (with no pixels wall)',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
                // {
                //     Type: 'image',
                //     SourceUrl: 'AAAAAAAAAAAAAAAAAA.jpg',
                // },
            ],
            images: [],
            video: '',

            // TODO: REVIEW THIS! (iahsjkdh)
            // layers: 'Layers: arena, paint pixels, safe areas, shots, feedback covers, countdown.',
            balancing: [
                { key: 'maxRound', param: 'Max Round (s)', values: { Kids: '60s', Beginner: '55s', Intermediate: '50s', Hard: '45s', VeryHard: '40s' } },
                { key: 'centerRandomness', param: 'Center randomness', values: { Kids: '0.45', Beginner: '0.50', Intermediate: '0.55', Hard: '0.58', VeryHard: '0.60' } },
                { key: 'pixelScore', param: 'Pixel score', values: { Kids: '8', Beginner: '8', Intermediate: '9', Hard: '10', VeryHard: '12' } },
                { key: 'shotPenalty', param: 'Shot penalty', values: { Kids: '4', Beginner: '6', Intermediate: '6', Hard: '8', VeryHard: '10' } },
                { key: 'shotSpeed', param: 'Shot speed', values: { Kids: '6', Beginner: '7', Intermediate: '8.5', Hard: '9.5', VeryHard: '10.5' } },
            ],

            GenericDescriptionContentList: [
                {
                    Id: 'paragraph-01',
                    Type: 'paragraph',
                    TextContent: 'Defend the center or invade it.',
                },
                {
                    Id: 'paragraph-02',
                    Type: 'paragraph',
                    TextContent: 'In Plot Invaders, players are positioned along the edges of the floor, launching paint shots toward the center grid. Each successful hit paints pixels, claiming territory for the attacking side. The color of the shooting is red.',
                },
                {
                    Id: 'paragraph-03',
                    Type: 'paragraph',
                    TextContent: 'Players in the center must defend the plot, dodging incoming shots and preventing the edges from painting the grid.',
                },
                {
                    Id: 'paragraph-04',
                    Type: 'paragraph',
                    TextContent: 'After each round, roles rotate:',
                },
                {
                    Type: 'list',
                    TextContentList: [
                        {
                            Id: 'list-01-01',
                            TextContent: 'Edge players move to the center',
                        },
                        {
                            Id: 'list-01-02',
                            TextContent: 'Center defenders shift to the edges',
                        },
                    ],
                },
                {
                    Id: 'paragraph-05',
                    Type: 'paragraph',
                    TextContent: 'This rotation ensures every player experiences both attack and defense.',
                },
                {
                    Id: 'paragraph-06',
                    Type: 'paragraph',
                    TextContent: 'The objective is to control or protect the center area by the end of each round through smart movement, timing, and coordination.',
                },
                {
                    Id: 'paragraph-07',
                    Type: 'paragraph',
                    TextContent: 'Invade. Defend. Rotate. Adapt.',
                },
            ],

        },
    ];

    getGames(): Game[]
    {
        return this.games;
    }

    getGameById(id: string): Game | undefined
    {
        return this.games.find(g => g.id === id);
    }
}
